import toastr from 'toastr';
import Service from '../../../utility/Service';
import { getPromoCodes } from './promoCodes';

export const PROMOCODE_DELETE_SUCCESS = "PROMOCODE_DELETE_SUCCESS";
export const PROMOCODE_DELETE_FAILURE = "PROMOCODE_DELETE_FAILURE";
export const PROMOCODE_DELETE_REQUEST = "PROMOCODE_DELETE_REQUEST";


export const promoCodeDeleteRequest = (data) => ({
    type: PROMOCODE_DELETE_REQUEST,
    loading: true,
    deleted: false
});

export const promoCOdeDeleteSuccess = (data) => ({
    type: PROMOCODE_DELETE_SUCCESS,
    loading: false,
    deleted: true
});

export const promoCodeDeleteFailure = () => ({
    type: PROMOCODE_DELETE_FAILURE,
    loading: false,
    deleted: false
});

export const deletePromoCode = (promoCodeId, pageNo, pageSize) => (dispatch, getState) => {
    toastr.remove()
    dispatch(promoCodeDeleteRequest());
    Service.delete("promo_code/" + promoCodeId, {},
        (response) => {
            if (response && response.status && response.status >= 200 && response.status < 300) {
                toastr.success(response.message ? response.message : 'Successfully Deleted the Service');
                dispatch(promoCOdeDeleteSuccess());
                dispatch(getPromoCodes(pageNo, pageSize));
            } else {
                dispatch(promoCodeDeleteFailure());
                toastr.error(response?.message || 'Something Went Wrong');
            }
        }
    )
};